import { render, staticRenderFns } from "./Own.vue?vue&type=template&id=76bee492&scoped=true&"
import script from "./Own.vue?vue&type=script&lang=js&"
export * from "./Own.vue?vue&type=script&lang=js&"
import style0 from "./Own.vue?vue&type=style&index=0&id=76bee492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bee492",
  null
  
)

export default component.exports